export default "/_next/static/chunks/fonts/Readex Pro Medium-3919599899ab91436d6c6b55bb392f66.ttf";